module.exports = __webpack_public_path__ + "media/gateway/zunify-logo-4dd200ad.png";